import React from 'react';
import WalletEarningsImg from '@src/assets/images/wallet-earnings.svg';
import PromoBanner from '@src/new-components/PromoBanner';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';
import { useTranslation } from 'react-i18next';
import {
  AccessTimeFilledRounded as InfoRoundedIcon,
  HistoryToggleOffRounded as HistoryToggleOffRoundedIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import {
  VOICE_REVENUE_TRANSACTION_STATUS,
  VOICE_REVENUE_TRANSACTION_STATUS_COLORS,
} from '@src/constants/voiceCloning';
import { UnderlinedUnit } from './ListVoiceCard/VoiceCard';

const PromoBannerEarnings = ({
  balance = 0,
  isShowActionButton,
  onRequestWithdrawal,
  onShowTransactionsHistory,
  note,
  status,
  isLoading,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isPending = status === VOICE_REVENUE_TRANSACTION_STATUS.PENDING;
  const isProcessing = status === VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING;
  const isInit = status === VOICE_REVENUE_TRANSACTION_STATUS.INIT;
  const isShowProcessingWithdrawal = isPending || isProcessing || isInit;

  const renderButtonHistory = () => (
    <CommonButton
      variant="outlined"
      textProps={{
        variantText: 'body-16-medium',
        color: COLOR.darkBlue,
      }}
      customStyle={{
        padding: '12px 16px',
        backgroundColor: 'transparent',
        height: '48px',
      }}
      onClick={onShowTransactionsHistory}
    >
      {t('transactionHistory')}
    </CommonButton>
  );
  const renderButtonRequestWithdrawal = () => (
    <CommonButton
      customStyle={{
        padding: '12px 16px',
        height: '48px',
      }}
      variant="contained"
      textProps={{
        variantText: 'body-16-medium',
        color: COLOR.darkBlue,
      }}
      startIcon={
        <AccountBalanceWalletRoundedIcon
          sx={{ color: COLOR.darkBlue, fontSize: '24px' }}
        />
      }
      onClick={onRequestWithdrawal}
    >
      {t('requestWithdrawal')}
    </CommonButton>
  );

  const renderStatus = () => {
    switch (status) {
      case VOICE_REVENUE_TRANSACTION_STATUS.INIT:
      case VOICE_REVENUE_TRANSACTION_STATUS.PENDING:
        return t('requestWithdrawalPending');
      case VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING:
        return t('requestWithdrawalProcessing');
      default:
        return '';
    }
  };
  const renderIcon = () => {
    switch (status) {
      case VOICE_REVENUE_TRANSACTION_STATUS.INIT:
      case VOICE_REVENUE_TRANSACTION_STATUS.PENDING:
        return (
          <HistoryToggleOffRoundedIcon
            className="icon"
            sx={{ color: VOICE_REVENUE_TRANSACTION_STATUS_COLORS[status] }}
          />
        );
      case VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING:
        return (
          <InfoRoundedIcon
            sx={{
              color: VOICE_REVENUE_TRANSACTION_STATUS_COLORS[status],
              fontSize: '24px',
            }}
          />
        );
      default:
        return '';
    }
  };

  const renderProcessingWithdrawal = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
      }}
    >
      {renderIcon()}
      <Typography
        variant="body-16-medium"
        color={VOICE_REVENUE_TRANSACTION_STATUS_COLORS[status]}
      >
        {renderStatus()}{' '}
        <Typography
          variant="body-16-medium"
          color={VOICE_REVENUE_TRANSACTION_STATUS_COLORS[status]}
          onClick={onRequestWithdrawal}
          sx={{
            textDecoration: 'underline',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          {t('viewDetail')}
        </Typography>
      </Typography>
    </Box>
  );

  return (
    <PromoBanner
      variant="variant-earnings-management"
      image={WalletEarningsImg}
      renderTitle={
        <Typography variant="body-16-regular" color={COLOR.descriptionUpload}>
          {t('titlePromoBannerEarnings')}
        </Typography>
      }
      renderDescription={
        <Typography variant="body-24-bold" color={COLOR.descriptionGray}>
          <UnderlinedUnit />
          {balance?.toLocaleString(language)}
        </Typography>
      }
      showCloseButton={false}
      actionButton={
        isShowActionButton &&
        !isLoading && (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
            }}
          >
            {isShowProcessingWithdrawal && renderProcessingWithdrawal()}
            {renderButtonHistory()}
            {!isShowProcessingWithdrawal && renderButtonRequestWithdrawal()}
          </div>
        )
      }
      note={note}
    />
  );
};

export default PromoBannerEarnings;
